import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=ff2d8d26&scoped=true&"
import script from "./fileTable.vue?vue&type=script&lang=js&"
export * from "./fileTable.vue?vue&type=script&lang=js&"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=ff2d8d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2d8d26",
  null
  
)

export default component.exports